import { render, staticRenderFns } from "./JobbookingCreateForm.vue?vue&type=template&id=5c45dfc5"
import script from "./JobbookingCreateForm.vue?vue&type=script&lang=ts"
export * from "./JobbookingCreateForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports